import React, { useState } from "react";

export default function ServiceReleasePricing({ headline, options }) {
  const [chosen, setChosen] = useState(null);

  return (
    <section className="pricing-section" id="pricing">
      <div className="container text-center">
        <div className="mu-eyebrow on-purple">Distribution Pricing</div>
        <h2 className="section-title" style={{ color: "#fff" }}>{headline}</h2>

        <div className="row g-4 justify-content-center mt-4">
          {options.map((plan) => (
            <div className="col-md-4" key={plan.name}>
              <div className={`plan-card ${plan.badge ? "plan-card-popular" : ""}`}>
                {plan.badge && <span className="plan-badge">{plan.badge}</span>}
                <div className="plan-name">{plan.name}</div>
                <div className="plan-price">
                  {plan.price}
                  <span>/{plan.period}</span>
                </div>
                <ul className="plan-features">
                  {plan.features.map((f, i) => (
                    <li key={i}>
                      <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.485 1.431a1.5 1.5 0 0 1 .084 2.118l-7.5 8.25a1.5 1.5 0 0 1-2.15.048l-3.75-3.75a1.5 1.5 0 1 1 2.122-2.122l2.628 2.628 6.447-7.088a1.5 1.5 0 0 1 2.119-.084Z" />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  className={plan.badge ? "btn-mu-dark plan-btn" : "btn-mu-dark plan-btn plan-btn-alt"}
                  onClick={() => setChosen(plan.name)}
                >
                  {chosen === plan.name ? "✓ Plan Selected" : "Choose Plan"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
